import { Component, OnDestroy, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { LanguageService } from '@fcom/ui-translate';
import { NavigationMenuService } from '@fcom/common/services';
import { getBookingStepLink } from '@fcom/common/utils/booking-common.utils';
import { TripType } from '@fcom/core/interfaces';

import { FooterOffer } from '../../interfaces';

@Component({
  selector: 'fin-footer-offer',
  styleUrls: ['./footer-offer.component.scss'],
  templateUrl: './footer-offer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FooterOfferComponent implements OnDestroy {
  private router = inject(Router);
  private languageService = inject(LanguageService);
  private navMenuService = inject(NavigationMenuService);

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TripType = TripType;

  offer = input.required<FooterOffer>();
  locationCode = computed((): string => this.offer().locationCode);
  visible = false;

  ngOnDestroy(): void {
    this.navMenuService.setFooterClosed();
  }

  toggleVisible(isVisible: boolean): void {
    this.visible = isVisible;

    if (this.visible) {
      this.navMenuService.setFooterOpen();
    } else {
      this.navMenuService.setFooterClosed();
    }
  }

  navigateTo(event: Event): void {
    event.preventDefault();
    this.router.navigateByUrl(
      getBookingStepLink(this.languageService.langValue, BOOKING_STEPS.ENTRY, { destination: this.locationCode() })
    );
  }
}
